import axiosInstance from '../axios/axiosInstance';
import { Subject } from '../model/response';

export const findAllSubject = async () => {
  const { data } = await axiosInstance.get<Subject[]>('subjects', { params: { fromCMS: true } });
  return data;
};

export const toggleSubjectWebviewActive = async (id: string) => {
  await axiosInstance.patch(`subjects/${id}/toggle-web-view-active`);
};
